export const getData = (jsonFileName: string, setResult: any) => {
  fetch(jsonFileName,
    {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    }
  )
    .then(function (response) {
      
      return response.json();
    }, (error) => {
      
      ;

    })
    .then(function (myJson) {
      if(myJson.hasOwnProperty('results')) {
        setResult(myJson.results);
      } else {
        setResult(myJson);
      }
    }, (error) => {
      
      ;
    });
};
